import { cn } from '@/lib/cn';

export const Ladekreis = ({ className }: { className?: string }) => (
  <span
    role="status"
    aria-label="Lädt"
    className={cn(
      'inline-block size-5 animate-spin rounded-full border-2 border-slate-300 border-t-marke-600',
      className,
    )}
  />
);

export const Ladeflaeche = ({ text = 'Einen Moment …' }: { text?: string }) => (
  <div className="flex flex-col items-center justify-center gap-3 py-16 text-slate-500 dunkel:text-slate-400">
    <Ladekreis className="size-8" />
    <p className="text-sm">{text}</p>
  </div>
);

/** Platzhalter beim Nachladen von Listen. */
export const Skelett = ({ zeilen = 3 }: { zeilen?: number }) => (
  <div className="space-y-3" aria-hidden="true">
    {Array.from({ length: zeilen }, (_, index) => (
      <div key={index} className="h-16 animate-pulse rounded-lg bg-slate-200 dunkel:bg-slate-800" />
    ))}
  </div>
);

export interface LeerProps {
  titel: string;
  text?: string;
  aktion?: React.ReactNode;
}

export const Leerzustand = ({ titel, text, aktion }: LeerProps) => (
  <div className="rounded-xl border border-dashed border-slate-300 px-6 py-12 text-center dunkel:border-slate-700">
    <p className="text-base font-medium text-slate-700 dunkel:text-slate-200">{titel}</p>
    {text && (
      <p className="mx-auto mt-1 max-w-md text-sm text-slate-500 dunkel:text-slate-400">{text}</p>
    )}
    {aktion && <div className="mt-4 flex justify-center">{aktion}</div>}
  </div>
);
